export default "__VITE_ASSET__C_zN07L8__"